import { Select } from "antd";
import styles from "./_WorkflowFilterBar.less";
import { formatCnpj } from "../../util/cnpj";
import React, { useEffect, useMemo, useState } from "react";
import useCollator from "../../hooks/useCollator";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import axios from "axios";
import { useSelector } from "react-redux";
import { filtrarWorkflow, filtroSelector, workflowSelector } from "../../store/workflow";
import useDispatchWithResult from "../../hooks/useDispatchWithResult";

export default function WorkflowFilterBarTipo() {
  const { compare, contains } = useCollator();
  const dispatch = useDispatchWithResult();
  const workflow = useSelector(workflowSelector);
  const filtro = useSelector(filtroSelector);
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const workflowId = workflow?.id;

  const nome = searchValue.trim();

  const handleChange = (tiposIds) => {
    dispatch(filtrarWorkflow({ tiposIds }));
  };

  useEffect(() => {
    if (workflowId) {
      setLoading(true);
      unwrapAxiosPromise(axios.get(`/workflows/${workflowId}/tipos-tarefas`, { params: { emUso: true } }))
        .then((data) => setTipos(data))
        .finally(() => setLoading(false));
    } else setTipos([]);
  }, [workflowId]);

  // const empresasFiltradas = useMemo(
  //   () =>
  //     empresas
  //       .filter((empresa) => contains(empresa.cnpj, nome) || contains(empresa.nome, nome))
  //       .sort((a, b) => compare(a.cnpj, b.cnpj))
  //       .slice(0, 50),
  //   [contains, empresas, nome],
  // );

  return (
    <Select allowClear className={styles["select"]} filterOption={false} loading={loading} mode="multiple" searchValue={searchValue} onSearch={setSearchValue} showSearch value={filtro.tiposIds} onChange={handleChange}>
      {tipos.map((tipo) => (
        <Select.Option key={tipo.id} value={tipo.id}>
          {tipo.nome}
        </Select.Option>
      ))}
    </Select>
  );
}
